// Blendet den in index.html inline gerenderten Splash (#vt-boot) aus, sobald die
// React-App gerendert hat. Erst Fade (CSS-Klasse), dann aus dem DOM entfernen.
export function dismissBootSplash(): void {
  const el = document.getElementById('vt-boot')
  if (!el) return
  el.classList.add('is-ready')
  window.setTimeout(() => el.remove(), 400)
}
